<template>
  <v-form ref="form" :disabled="$loader.loading">
    <v-row>
      <v-col cols="3">
        <v-text-field
          v-model="model.name"
          variant="outlined"
          label="Nome"
          :rules="[rules.required]"
          :readonly="readonly"
        />
      </v-col>
      <v-col cols="2">
        <v-select
          v-model="model.active"
          :items="status"
          item-text="title"
          item-value="value"
          variant="outlined"
          label="Status"
          :readonly="readonly"
        />
      </v-col>
      <v-col cols="2">
        <v-text-field
          v-model="model.zipcode"
          variant="outlined"
          label="CEP"
          :rules="[rules.required]"
          :readonly="readonly"
        />
      </v-col>
      <v-col cols="2">
        <v-select
          v-model="model.state"
          variant="outlined"
          label="Estado"
          :rules="[rules.required]"
          :readonly="readonly"
          :items="['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO']"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="model.city"
          variant="outlined"
          label="Cidade"
          :rules="[rules.required]"
          :readonly="readonly"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="model.district"
          variant="outlined"
          label="Bairro"
          :rules="[rules.required]"
          :readonly="readonly"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="model.street"
          variant="outlined"
          label="Rua"
          :rules="[rules.required]"
          :readonly="readonly"
        />
      </v-col>
      <v-col cols="1">
        <v-text-field
          v-model="model.number"
          variant="outlined"
          label="Número"
          :rules="[rules.required]"
          :readonly="readonly"
        />
      </v-col>
      <v-col cols="2">
        <v-text-field
          v-model="model.complement"
          variant="outlined"
          label="Complemento"
          :readonly="readonly"
        />
      </v-col>
      <v-col v-if="!readonly" cols="2">
        <v-btn
          color="primary"
          block
          :loading="$loader.loading"
          size="x-large"
          @click="submit"
        >
          {{ model.id === undefined ? 'Criar' : 'Salvar' }}
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script setup lang="ts">
import { ref, useTemplateRef, watchEffect } from 'vue'
import { equals } from '@/helpers/rules/equals'
import type PointOfSale from '@/types/PointOfSale'
import { useSnackBar } from '@/stores/snackbar'
import type { VForm } from 'vuetify/lib/components'

interface Props {
  pos?: PointOfSale
  readonly?: boolean
}

const { pos, readonly = false } = defineProps<Props>()

const $emit = defineEmits<{
  submit: [model: PointOfSale]
}>()

const model = ref<PointOfSale>(pos ?? { active: true } as PointOfSale)

const status = [ { title: 'Ativo', value: true }, { title: 'Inativo', value: false } ]

const rules = {
  required: (v: string) => (!!v || readonly || v == String(false)) || 'Campo obrigatório',
  producers: (v: string) => v.length > 0 || 'Selecione pelo menos um produtor',
  equals,
}

watchEffect(() => {
  if (pos === undefined) return

  model.value = pos
})

const form = useTemplateRef<VForm>('form')

async function submit() {
  if (!form.value) return

  const { valid } = await form.value.validate()

  if (!valid) {
    useSnackBar().show(
      'Verifique se os campos e cargos foram preenchidos corretamente',
      'warning',
    )
    return
  }

  $emit('submit', model.value)
}
</script>
